import { ProjectIntegration, ProviderType } from '../../models/project-integration.model';

/**
 * Was jemand fuer eine Bug-Anlage gewaehlt hat (NEX-1205, als Baustein NEX-1348). Nur die
 * Wahl selbst; was daraus folgt, beantwortet {@link resolveBugTargets}. Der Aufrufer haelt
 * sie — der Runner fuer den ganzen Durchlauf, nicht je Schritt.
 */
export interface BugTargetChoice {
  readonly provider: ProviderType | null;
  readonly boardId: string | null;
}

export const NO_BUG_TARGET_CHOICE: BugTargetChoice = { provider: null, boardId: null };

/** Was eine Wahl auf den gegebenen Zielen bedeutet. */
export interface BugTargetOptions {
  readonly providers: ProviderType[];
  /** Der gewaehlte Anbieter, sonst der erste verfuegbare. */
  readonly provider: ProviderType | null;
  readonly boards: ProjectIntegration[];
  /** Die Verbindung, in der der naechste Vorgang entsteht. */
  readonly target: ProjectIntegration | null;
  readonly offersTrackerChoice: boolean;
  readonly offersBoardChoice: boolean;
  readonly offersChoice: boolean;
}

/**
 * Die Regeln der Auswahl an einer Stelle — fuer den Baustein, der sie zeigt, und den
 * Aufrufer, der auch dort anlegt, wo es nichts zu waehlen gibt. Eine Wahl, die auf die
 * Ziele nicht (mehr) passt, faellt auf das jeweils erste zurueck.
 */
export function resolveBugTargets(targets: readonly ProjectIntegration[], choice: BugTargetChoice): BugTargetOptions {
  const providers = [...new Set(targets.map((integration) => integration.providerType))];
  const provider = choice.provider && providers.includes(choice.provider) ? choice.provider : (providers[0] ?? null);
  const boards = targets.filter((integration) => integration.providerType === provider);
  const target = boards.find((board) => board.id === choice.boardId) ?? boards[0] ?? null;
  const offersTrackerChoice = providers.length > 1;
  const offersBoardChoice = boards.length > 1;
  return {
    providers,
    provider,
    boards,
    target,
    offersTrackerChoice,
    offersBoardChoice,
    offersChoice: offersTrackerChoice || offersBoardChoice,
  };
}

/** Das Board des vorigen Anbieters gilt hier nicht; die Auswahl faellt auf dessen erstes. */
export function chooseBugProvider(provider: ProviderType): BugTargetChoice {
  return { provider, boardId: null };
}

export function chooseBugBoard(choice: BugTargetChoice, boardId: string): BugTargetChoice {
  return { ...choice, boardId };
}
